"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
require("antd/lib/divider/style");
var _divider = _interopRequireDefault(require("antd/lib/divider"));
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/menu/style");
var _menu = _interopRequireDefault(require("antd/lib/menu"));
require("antd/lib/tag/style");
var _tag = _interopRequireDefault(require("antd/lib/tag"));
var _react = _interopRequireWildcard(require("react"));
var _SearchInputWithFilters = _interopRequireDefault(require("./SearchInputWithFilters"));
var _SearchResults = _interopRequireDefault(require("./SearchResults"));
var _api = require("../api");
var _scrollTo = _interopRequireDefault(require("antd/es/_util/scrollTo"));
var _BackToChannelLink = _interopRequireDefault(require("./BackToChannelLink"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ahooks = require("ahooks");
var _lodash = require("lodash");
var _constants = require("../constants");
var _components = require("../../../../../components");
var _utils = require("../../../../../utils");
var _utils2 = require("../../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var SearchPanel = function SearchPanel(_ref) {
  var onClose = _ref.onClose,
    channel = _ref.channel,
    panelOpen = _ref.panelOpen;
  // Search context and corresponding dropdown controls
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showContextDropdown = _useState2[0],
    setShowContextDropdown = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    searchContext = _useState4[0],
    setSearchContext = _useState4[1];
  // Search items control for second dropdown, loading controls and selected search item for the same
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedSearchItem = _useState6[0],
    setSelectedSearchItem = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = _slicedToArray(_useState7, 2),
    searchItems = _useState8[0],
    setSearchItems = _useState8[1];
  var _useState9 = (0, _react.useState)(),
    _useState10 = _slicedToArray(_useState9, 2),
    loadingSearchItems = _useState10[0],
    setLoadingSearchItems = _useState10[1];
  // Input and search texts are different, search text is only being set on actual
  // search, input text follows current state for utility needs
  var _useState11 = (0, _react.useState)(),
    _useState12 = _slicedToArray(_useState11, 2),
    searchText = _useState12[0],
    setSearchText = _useState12[1];
  var _useState13 = (0, _react.useState)(),
    _useState14 = _slicedToArray(_useState13, 2),
    inputText = _useState14[0],
    setInputText = _useState14[1];
  // Search filters for useChannelSearch
  var _useState15 = (0, _react.useState)(_constants.defaultFilters),
    _useState16 = _slicedToArray(_useState15, 2),
    filters = _useState16[0],
    setFilters = _useState16[1];
  var сontainerRef = (0, _react.useRef)();
  var inputRef = (0, _react.useRef)();
  var _useCustomChatContext = (0, _utils2.useCustomChatContext)(),
    appMenuCollapsed = _useCustomChatContext.appMenuCollapsed;
  var isMobileSearch = (0, _utils.isMobileOrTablet)() && panelOpen;
  var _useChannelSearch = (0, _api.useChannelSearch)(channel, searchText, setSearchText, filters),
    loadingResults = _useChannelSearch.loading,
    searchResults = _useChannelSearch.results,
    hasMore = _useChannelSearch.hasMore,
    prev = _useChannelSearch.prev,
    next = _useChannelSearch.next,
    page = _useChannelSearch.page,
    sizeLabel = _useChannelSearch.sizeLabel,
    clearSearchResults = _useChannelSearch.clearSearchResults;
  (0, _react.useEffect)(function () {
    var scrollToClass = (0, _utils.isMobileOrTablet)() ? 'channel-search-container' : 'search-container-desktop';
    (0, _scrollTo.default)(0, {
      getContainer: function getContainer() {
        return document.getElementsByClassName(scrollToClass)[0];
      }
    });
  }, [page]);

  // This one is needed to hide search context dropdown
  // after the click outside of general search container
  (0, _ahooks.useClickAway)(function () {
    setShowContextDropdown(false);
  }, сontainerRef);

  // back to channel button for Desktop only, pops along the search results
  var onBackToChannel = function onBackToChannel() {
    setShowContextDropdown(false);
    clearSearchResults();
  };
  var clearSearch = function clearSearch() {
    setSearchContext();
    setInputText();
    setSelectedSearchItem();
    setFilters(_constants.defaultFilters);
    setSearchItems();
  };

  // We need to follow input text even if the search context is not selected
  var onChangeWithoutSearchContext = function onChangeWithoutSearchContext(event) {
    var _event$target;
    setInputText(event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value);
  };

  // handler for custom clear search input functionality
  var onInputClear = function onInputClear() {
    clearSearch();
    setShowContextDropdown(true);
  };
  var onUserSearch = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
      var res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // if no filtered item set, we still need to follow input text
              if (!selectedSearchItem) {
                onChangeWithoutSearchContext(event);
              }
              if (!(event !== null && event !== void 0 && event.target.value)) {
                _context.next = 11;
                break;
              }
              _context.prev = 2;
              setLoadingSearchItems(true);
              _context.next = 6;
              return channel.queryMembers({
                name: {
                  $autocomplete: event === null || event === void 0 ? void 0 : event.target.value
                }
              });
            case 6:
              res = _context.sent;
              if (res !== null && res !== void 0 && res.members) {
                setSearchItems(res === null || res === void 0 ? void 0 : res.members.map(function (member) {
                  return {
                    key: member === null || member === void 0 ? void 0 : member.user.id,
                    label: member === null || member === void 0 ? void 0 : member.user.name
                  };
                }));
              }
            case 8:
              _context.prev = 8;
              setLoadingSearchItems(false);
              return _context.finish(8);
            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2,, 8, 11]]);
    }));
    return function onUserSearch(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var onSearchItemsDropdownSelect = function onSearchItemsDropdownSelect(_ref3) {
    var key = _ref3.key;
    var selectedItem = searchItems === null || searchItems === void 0 ? void 0 : searchItems.find(function (item) {
      return item.key === key;
    });
    setInputText();
    setSelectedSearchItem(selectedItem);
    setFilters(function (current) {
      return _objectSpread(_objectSpread({}, current), {}, _defineProperty({}, searchContext, [selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.key]));
    });
  };

  // Show initial dropdown on input click
  var onInputFocus = function onInputFocus() {
    if (!searchContext) {
      setShowContextDropdown(true);
    }
  };

  // Custom actions to make sure backspace/delete and Input.Search clear actions are ok
  var handleInputKeyActions = function handleInputKeyActions(event) {
    var deleteKeysPressed = (event === null || event === void 0 ? void 0 : event.key) === 'Delete' || (event === null || event === void 0 ? void 0 : event.key) === 'Backspace';
    if (!(event !== null && event !== void 0 && event.target.value) && deleteKeysPressed) {
      clearSearch();
      setShowContextDropdown(true);
    }
    if (event !== null && event !== void 0 && event.target.value && selectedSearchItem && deleteKeysPressed) {
      // For general case we clear search items and unset selected search item
      setSelectedSearchItem();
      setSearchItems();
      setFilters(_constants.defaultFilters);
      // But, if we have static search config for this option, we also need to show
      // search items dropdown straight away, filling it from corresponding config
      if (currentConfigItem !== null && currentConfigItem !== void 0 && currentConfigItem.staticSearchOptions) {
        setSearchItems(currentConfigItem === null || currentConfigItem === void 0 ? void 0 : currentConfigItem.staticSearchOptions);
      }
    }
  };
  var onSearchContextDropdownSelect = function onSearchContextDropdownSelect(_ref4) {
    var key = _ref4.key;
    setSearchContext(key);
    setShowContextDropdown(false);
    inputRef.current.focus({
      cursor: 'start'
    });
    // If we have static search config for this option, show search items dropdown straight away. Can't use global
    // currentConfigItem even with useMemo and deps, since it is still not computed after search context change above
    var configItem = contextDropdownConfig.find(function (item) {
      return item.label === key;
    });
    if (configItem !== null && configItem !== void 0 && configItem.staticSearchOptions) {
      setSearchItems(configItem === null || configItem === void 0 ? void 0 : configItem.staticSearchOptions);
    }
  };

  // Last item here has 'staticSearchOptions' property to match the case where we don't
  // have to fetch our searchItems and we set it straight away from corresponding config
  var contextDropdownConfig = [{
    label: 'from',
    text: 'member',
    spacerClass: 'pr-from',
    placeholder: 'Search member...',
    searchDropDownVisible: !(0, _lodash.isEmpty)(searchItems) && !selectedSearchItem && inputText,
    contextSearch: onUserSearch
  }, {
    label: 'mentions',
    text: 'member',
    spacerClass: 'pr-mentions',
    placeholder: 'Search member...',
    searchDropDownVisible: !(0, _lodash.isEmpty)(searchItems) && !selectedSearchItem && inputText,
    contextSearch: onUserSearch
  }, {
    label: 'has',
    text: 'image, video or file',
    spacerClass: 'pr-has',
    placeholder: 'Select attachment type...',
    searchDropDownVisible: !(0, _lodash.isEmpty)(searchItems) && !selectedSearchItem,
    contextSearch: _lodash.noop,
    staticSearchOptions: _constants.attachmentSearchItemsConfig
  }];
  var currentConfigItem = contextDropdownConfig.find(function (item) {
    return item.label === searchContext;
  });
  var currentInputValue = inputText || (selectedSearchItem === null || selectedSearchItem === void 0 ? void 0 : selectedSearchItem.label);
  var contextDropdownMenu = /*#__PURE__*/_react.default.createElement(_menu.default, {
    onClick: onSearchContextDropdownSelect,
    className: "search-context-dropdown-items"
  }, contextDropdownConfig.map(function (value) {
    return /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
      key: value === null || value === void 0 ? void 0 : value.label,
      className: "flex items-center py-[8px] min-h-[20px] lg:py-[4px]"
    }, /*#__PURE__*/_react.default.createElement(_components.Icon, {
      type: "add-heavy-16",
      className: "mr-[8px]",
      size: 12
    }), /*#__PURE__*/_react.default.createElement(_tag.default, {
      className: "context-tag border-0 bg-transparent px-[0px] mr-[4px] tw-label-medium lg:tw-body-sm-medium"
    }, value === null || value === void 0 ? void 0 : value.label, ":"), /*#__PURE__*/_react.default.createElement("span", {
      className: "tag-text tw-label-regular lg:tw-body-sm-regular"
    }, value === null || value === void 0 ? void 0 : value.text));
  }));
  var searchDropdownMenu = /*#__PURE__*/_react.default.createElement(_menu.default, {
    onClick: onSearchItemsDropdownSelect,
    className: "selected-search-context-dropdown-items"
  }, searchItems === null || searchItems === void 0 ? void 0 : searchItems.map(function (value) {
    return /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
      className: "py-[8px] lg:py-[4px] tw-label-regular lg:tw-body-sm-regular",
      key: value === null || value === void 0 ? void 0 : value.key
    }, value === null || value === void 0 ? void 0 : value.label);
  }));

  // Search input and dropdown partial
  var searchInput = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react.default.createElement(_SearchInputWithFilters.default, {
      loading: loadingResults
      // These are input events
      ,
      onFocus: onInputFocus,
      onKeyDown: handleInputKeyActions,
      onSearch: setSearchText,
      onChange: searchContext ? currentConfigItem.contextSearch : onChangeWithoutSearchContext,
      onClear: onInputClear
      // These are used to build and maintain search context and search item dropdowns
      ,
      additionalClass: currentConfigItem === null || currentConfigItem === void 0 ? void 0 : currentConfigItem.spacerClass,
      searchContext: searchContext,
      searchDropdownMenu: searchDropdownMenu,
      contextDropdownMenu: contextDropdownMenu,
      showContextDropdown: showContextDropdown,
      currentConfigItem: currentConfigItem
      // Current values and ref
      ,
      inputText: inputText,
      value: currentInputValue,
      ref: inputRef
    });
  }, [searchContext, showContextDropdown, contextDropdownMenu, searchDropdownMenu, currentInputValue, currentConfigItem, inputText]);

  // Search results list partial
  var searchResultsList = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react.default.createElement(_SearchResults.default, {
      searchResults: searchResults,
      loading: loadingResults,
      onClose: clearSearchResults,
      hasMore: hasMore,
      prev: prev,
      next: next,
      page: page,
      sizeLabel: sizeLabel
    });
  }, [searchResults, loadingResults, hasMore, page, sizeLabel]);
  if (isMobileSearch) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('channel-search-container', {
        'channel-search-container--open mth-else': panelOpen
      })
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "channel-search__panel"
    }, /*#__PURE__*/_react.default.createElement(_row.default, {
      className: "channel-search__panel-close-row"
    }, /*#__PURE__*/_react.default.createElement(_components.Icon, {
      type: "close-16",
      onClick: onClose,
      className: "channel-search__close-icon"
    })), /*#__PURE__*/_react.default.createElement(_divider.default, null), /*#__PURE__*/_react.default.createElement(_row.default, {
      className: "channel-search__panel-search-input-row"
    }, /*#__PURE__*/_react.default.createElement("span", {
      ref: сontainerRef
    }, /*#__PURE__*/_react.default.createElement(_spin.default, {
      spinning: !!loadingResults
    }, searchInput))), searchResults && searchResultsList));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "search-container-desktop"
  }, searchResults && /*#__PURE__*/_react.default.createElement(_BackToChannelLink.default, {
    onClick: onBackToChannel
  }), /*#__PURE__*/_react.default.createElement("span", {
    ref: сontainerRef
  }, /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: !!loadingResults && loadingSearchItems
  }, searchInput)), searchResults && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('channel-search-container channel-search-container--open mth-else', {
      'app-menu-collapsed': appMenuCollapsed
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "channel-search__panel"
  }, searchResultsList)));
};
var _default = SearchPanel;
exports.default = _default;